import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { AppConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.prod) {
  enableProdMode();
}

bootstrapApplication(AppComponent, AppConfig).catch((error) => {
  console.error('error', error);
});
